import { G } from "../../constants/theme";

export default function StatBox({ num, label }) {
  return (
    <div
      style={{
        background: G.surface,
        padding: "22px 26px",
        borderRight: `1px solid ${G.border}`,
      }}
    >
      <div
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 34,
          color: G.green,
          lineHeight: 1,
          marginBottom: 3,
        }}
      >
        {num}
      </div>
      <div
        style={{
          fontFamily: "monospace",
          fontSize: 9,
          letterSpacing: 1.5,
          color: G.muted,
          textTransform: "uppercase",
        }}
      >
        {label}
      </div>
    </div>
  );
}
